import { render, staticRenderFns } from "./display-field.vue?vue&type=template&id=2a55c6b7&"
import script from "./display-field.vue?vue&type=script&lang=js&"
export * from "./display-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports